export const EXPIRED_GUIDE_MODE = {
  NONE: 'none',
  GRACE: 'grace',
  SEVERE: 'severe'
}

/** 全部设备过期超 30 天且无有效未绑单时的独立续费页（禁止进设备 dashboard） */
export const EXPIRED_PURCHASE_PATH = '/expired-purchase'

/** 详情页不展示宽限期遮罩的路径 */
export const EXPIRED_GUIDE_DETAIL_EXCLUDED_PATHS = [
  '/dashboard',
  '/android/dashboard',
  '/android/local/dashboard',
  '/pages/account-settings/account',
  '/android/local/permission-check',
  '/setup',
  '/android/classification',
  '/android/local/setup',
  '/android/setup',
  '/android/nodevice-setup',
  '/ios/setup',
  '/ios/extreme-verification',
  '/guide',
  '/settings',
  '/expired-purchase'
]

/** 全屏严重过期引导也不展示的路径（引导/设置流程） */
export const EXPIRED_GUIDE_SEVERE_EXCLUDED_PATHS = [
  '/setup',
  '/android/classification',
  '/android/local/setup',
  '/android/setup',
  '/android/nodevice-setup',
  '/ios/setup',
  '/ios/extreme-verification',
  '/guide',
  '/settings',
]

export const EXPIRED_GUIDE_DASHBOARD_PATHS = ['/dashboard', '/android/dashboard', '/android/local/dashboard']

export const resolveDashboardPathByMode = mode => {
  if (mode === 'Android-Cloud') return '/android/dashboard'
  if (mode === 'Android-Local') return '/android/local/dashboard'

  return '/dashboard'
}
